/* eslint-disable max-len */
import React from 'react';
import { render } from 'react-dom';

import { AppLightingCollectionsSlideOut } from 'apps/lightingCollectionsSlideOut/desktop';

function initLightingCollectionsSlideOut (shortSku: string, lightingCollectionName: string) {

	const lightingCollectionsSlideOutContainer = document.getElementById('lightingCollectionsSlideOutContainer');

	render(<AppLightingCollectionsSlideOut shortSku={shortSku} lightingCollectionName={lightingCollectionName} />, lightingCollectionsSlideOutContainer);

}
export default initLightingCollectionsSlideOut;
